import {Map} from 'maplibre-gl';
import {FeatureCollection} from 'geojson';
import { MapContent, MapContentBase } from '../MapContent';
import {TrackStyles} from '../../../../../configuration/model/TrackStyles';
import {MapContentSource} from '../MapContentSource';
import {LocationInfo} from '../../../../models/AddressLookup';
import {ShiftTrackLayer} from './ShiftTrackLayer';
import {AddressMarkerLayer} from './AddressMarkerLayer';
import {ShiftTrackArrowsLayer} from './ShiftTrackArrowsLayer';
import { Protocol } from 'pmtiles';

export class AddressLookupVisitMapContent extends MapContentBase implements MapContent {

  private markersSource: MapContentSource = new MapContentSource('markers-source');
  private tracksSource: MapContentSource = new MapContentSource('tracks-source');
  private markerLayer: AddressMarkerLayer = new AddressMarkerLayer(this.markersSource);
  private shiftTrackLayer: ShiftTrackLayer;
  private shiftTrackArrowsLayer: ShiftTrackArrowsLayer = new ShiftTrackArrowsLayer(this.tracksSource);

  constructor(
    marker: LocationInfo,
    shiftTrackFeatureCollection: FeatureCollection,
    trackStyles: TrackStyles,
  ) {
    super();
    this.markerLayer.addMarker(marker);
    this.tracksSource.loadFromFeatureCollection(shiftTrackFeatureCollection);
    this.shiftTrackLayer = new ShiftTrackLayer(this.tracksSource, trackStyles, null);
  }

  load(map: Map, protocol: Protocol, zoomToFeatures: boolean) {
    this.map = map;
    this.firstSymbolLayerId = this.getFirstSymbolLayerId();

    this.markersSource.updateMap(this.map);
    this.tracksSource.updateMap(this.map);
    this.map.addLayer(this.shiftTrackLayer.toLayerSpecification(), this.firstSymbolLayerId);
    this.map.addLayer(this.shiftTrackArrowsLayer.toLayerSpecification(), this.firstSymbolLayerId);
    this.map.addLayer(this.markerLayer.toLayerSpecification());

    if (zoomToFeatures) {
      this.markerLayer.zoomToVisibleFeatures(this.map);
    }
  }

  unload() {
    this.map.removeLayer(this.shiftTrackLayer.layerId);
    this.map.removeLayer(this.shiftTrackArrowsLayer.layerId);
    this.map.removeLayer(this.markerLayer.layerId);
    this.map.removeSource(this.markersSource.sourceId);
    this.map.removeSource(this.tracksSource.sourceId);
    this.map = null;
  }
}
